import { useCallback, useEffect, useState } from "react";

interface ViewportValues {
  offsetTop: number;
  offsetLeft: number;
  pageTop: number;
  pageLeft: number;
  scale: number;
  width: number;
  height: number;
}

export const useVisualViewport = () => {
  const [viewportState, setViewportState] = useState<ViewportValues | null>(
    window?.visualViewport ?? null,
  );

  const updateViewportState = useCallback(
    () =>
      setViewportState(
        window.visualViewport ?
          {
            offsetTop: window?.visualViewport?.offsetTop,
            offsetLeft: window?.visualViewport?.offsetLeft,
            pageTop: window?.visualViewport?.pageTop,
            pageLeft: window?.visualViewport?.pageLeft,
            scale: window?.visualViewport?.scale,
            width: window?.visualViewport?.width,
            height: window?.visualViewport?.height,
          }
        : null,
      ),
    [],
  );

  useEffect(() => {
    updateViewportState();

    window?.visualViewport?.addEventListener("resize", updateViewportState);
    window?.visualViewport?.addEventListener("scroll", updateViewportState);

    return () => {
      window?.visualViewport?.removeEventListener(
        "resize",
        updateViewportState,
      );
      window?.visualViewport?.removeEventListener(
        "scroll",
        updateViewportState,
      );
    };
  }, [updateViewportState]);

  return viewportState;
};
